import React, { useState } from "react";
import { SearchIcon } from "@heroicons/react/solid";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";

import apiUser from "../../../redux2/user/apiUser";
import Loading from "../../../components/Loading";

const SendSMS = ({ openSendSMS, setOpenSendSMS, companies }) => {
  const [filteredCompanies, setFilteredCompanies] = useState(companies);
  const [selectedCompanies, setSelectedCompanies] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [form, setForm] = useState({
    message: "",
  });

  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    setSelectedCompanies(isChecked ? companies?.map((c) => c._id) : []);
  };

  const handleCompanySelect = (e, company) => {
    const isChecked = e.target.checked;
    setSelectedCompanies((prevSelected) =>
      isChecked
        ? [...prevSelected, company?._id]
        : prevSelected.filter((c) => c !== company?._id)
    );
  };

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    const filtered = companies.filter((company) =>
      company.name.toLowerCase().includes(value)
    );
    setFilteredCompanies(filtered);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prevForm) => ({
      ...prevForm,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    setIsLoading(true);
    e.preventDefault();

    if (form.message === "") {
      toast.error("Please enter a message");
      return;
    }

    const data = {
      companyList: selectedCompanies,
      message: form.message,
    };

    try {
      await apiUser.sendPromotionSMS(data);
      toast.success("SMS sent successfully");
      setForm({
        message: "",
      });
      setSelectedCompanies([]);
      setOpenSendSMS(false);
    } catch (error) {
      toast.error(error.response.data.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    setOpenSendSMS(false);
    setForm({
      message: "",
    });
    setSelectedCompanies([]);
  };

  if (isLoading) {
    return <Loading />;
  }

  return (
    <Modal
      show={openSendSMS}
      onHide={handleClose}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-right"
    >
      <Modal.Body>
        <div className="p-6 mx-auto w-full max-w-3xl bg-white rounded-lg">
          <h5 className="mb-6 text-3xl font-semibold text-center text-gray-800">
            Select Agencies for SMS
          </h5>
          <form onSubmit={handleSubmit}>
            <div className="flex justify-between items-center mb-6">
              <div className="flex items-center w-full">
                <input
                  type="checkbox"
                  id="select-all"
                  className="w-5 h-5 text-indigo-600 transition duration-200 ease-in-out form-checkbox focus:ring-indigo-500"
                  onChange={handleSelectAll}
                />
                <label
                  htmlFor="select-all"
                  className="mt-2 ml-3 text-lg font-medium text-gray-700 cursor-pointer"
                >
                  Select All
                </label>
              </div>

              <div className="relative w-full max-w-sm text-end">
                <input
                  type="text"
                  placeholder="Search agencies..."
                  className="py-2 pr-4 pl-10 w-full text-sm text-gray-700 rounded-lg border border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500"
                  onChange={handleSearch}
                />
                <div className="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none">
                  <SearchIcon className="w-5 h-5 text-gray-400" />
                </div>
              </div>
            </div>

            <div className="space-y-4">
              {filteredCompanies?.map((company, index) => (
                <div
                  className="flex items-center p-4 bg-gray-50 rounded-lg shadow-sm transition duration-200 hover:bg-gray-100"
                  key={company._id}
                >
                  <span className="mr-4 text-sm font-medium text-gray-600">
                    {index + 1}.
                  </span>
                  <label
                    htmlFor={`company-list-${company._id}`}
                    className="flex justify-between w-full cursor-pointer"
                  >
                    <span className="text-base font-medium text-gray-800">
                      {company.name}
                    </span>
                    <input
                      type="checkbox"
                      id={`company-list-${company._id}`}
                      className="w-5 h-5 text-indigo-600 transition duration-200 form-checkbox"
                      checked={selectedCompanies.some((c) => c === company._id)}
                      onChange={(e) => handleCompanySelect(e, company)}
                    />
                  </label>
                </div>
              ))}
            </div>
            <div className="flex flex-row gap-4 mt-4">
              <textarea
                type="number"
                id="message"
                className="block p-2 w-full text-lg text-black bg-white rounded-lg border-black border-1 focus:border-primary-300 focus:ring focus:ring-primary-200 focus:ring-opacity-50"
                onWheel={(e) => e.target.blur()}
                name="message"
                placeholder="Message"
                onChange={handleChange}
                value={form.message}
                required
                rows={4}
              />
            </div>
          </form>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="flex gap-4 justify-end w-full">
          <button
            type="button"
            className="px-5 py-2 text-gray-700 bg-gray-200 rounded-md transition duration-200 hover:bg-gray-300"
            onClick={handleClose}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="px-5 py-2 text-white bg-indigo-600 rounded-md transition duration-200 hover:bg-indigo-700"
            onClick={handleSubmit}
            disabled={isLoading}
          >
            Send SMS
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default SendSMS;
